import $ from '@vaersaagod/tools/Dom';

export default (el, props) => {
    const output = $(el).find('[data-output]');
    const target = Date.parse(props.target);

    const padNumber = value => (value > 9 ? value : `0${value}`);

    const getDiff = ms => {
        let s = Math.floor(ms / 1000);
        let m = Math.floor(s / 60);
        s %= 60;
        let h = Math.floor(m / 60);
        m %= 60;
        const d = Math.floor(h / 24);
        h %= 24;

        return { d, h: padNumber(h), m: padNumber(m), s: padNumber(s) };
    };

    const getDateDiff = () => getDiff(target - Date.now());

    const tick = () => {
        const parts = getDateDiff();
        if (parts.d) {
            const daysText = parts.d === 1 ? 'dag' : 'dager';
            output.text(`${padNumber(parts.d)} ${daysText} ${parts.h}:${parts.m}:${parts.s}`);
        } else {
            output.text(`${parts.h}:${parts.m}:${parts.s}`);
        }
    };

    const init = () => {
        setInterval(tick, 1000);
    };

    const destroy = () => {

    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Countdown.js